//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FileSaver from "file-saver";
export default {
  name: "",
  data() {
    return {
      wkt_domain_name: localStorage.getItem("wkt_domain_name"),
      form_name: this.$route.query.list_item,
      list_ary: [],
      loading: false
    };
  },
  mounted() {
    let formData = new FormData();
    formData.append("action_type", "get_pdf_file");
    formData.append("form", this.$route.query.form);
    if (this.$route.query.type) {
      formData.append("type_id", this.$route.query.type);
    }

    formData.append("orderByObj", "id");
    formData.append("orderBy", "desc");
    this.loading = true;
    this.$http({
      url: "/search/common.php",
      method: "post",
      data: formData
    }).then(res => {
      this.loading = false;
      this.list_ary = res.data.data.reverse();
    });
  },
  components: {},
  methods: {
    pre_pdf(item) {
      let formData = new FormData();
      formData.append("form", this.$route.query.form);
      formData.append("id", item.id);
      formData.append("key", "scan_num");
      formData.append("action_type", "add_num");
      this.$http({
        url: "/update/common.php",
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.common.pre_pdf(item);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/list.vue